export interface IUserIntraModule {
    code: string;
    name: string;
    externalCode: string;
    inUse: boolean;
}

export class UserIntraModule implements IUserIntraModule {
    code: string;
    name: string;
    externalCode: string;
    inUse: boolean;

    constructor();
    constructor(obj: IUserIntraModule);
    constructor(obj?: any) {
        this.code = obj && obj.code || "";
        this.name = obj && obj.name || "";
        this.externalCode = obj && obj.externalCode || "";
        this.inUse = obj && obj.inUse || false;
    }
}

export class UserSaveIntraModule {
    code: string;
    externalCode: string;

    constructor();
    constructor(obj: IUserIntraModule);
    constructor(obj?: any) {
        this.code = obj && obj.code || "";
        this.externalCode = obj && obj.externalCode || "";
    }
}